var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconForms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "59.58,59.61 0.42,59.61 0.42,5.27 8.62,5.27 8.62,8.23 3.38,8.23 3.38,56.66 56.62,56.66 56.62,8.23  51.21,8.23 51.21,5.27 59.58,5.27  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18.91,
    className: "st0",
    width: 35.44,
    height: 2.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 26.07,
    className: "st0",
    width: 27.39,
    height: 2.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 33.23,
    className: "st0",
    width: 35.44,
    height: 2.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 40.39,
    className: "st0",
    width: 27.39,
    height: 2.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 47.56,
    className: "st0",
    width: 35.44,
    height: 2.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.19,11.87h-38.4V0.39h38.4V11.87z M13.75,8.91h32.48V3.34H13.75V8.91z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForms);
export default __webpack_public_path__ + "static/media/icon_forms.44b50308c7e01dcffb572ad2e393a88c.svg";
export { ForwardRef as ReactComponent };